import { FC } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

interface ExportStatusConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  transactionNumber: string;
  isPending: boolean;
}

export const ExportStatusConfirmDialog: FC<ExportStatusConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  transactionNumber,
  isPending,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: "#003059", color: "white" }}>
        Export-Status ändern
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <DialogContentText>
          Möchten Sie den Exportstatus dieser Transaktion wirklich auf „Nicht
          exportiert“ zurücksetzen?
          <br />
          <br />
          Transaktionsnummer: <strong>{transactionNumber}</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={isPending} variant="outlined">
          Abbrechen
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isPending}
          variant="contained"
          sx={{
            bgcolor: "#003059",
            color: "white",
            "&:hover": { bgcolor: "#6FBF99" },
          }}
        >
          {isPending ? "Wird aktualisiert..." : "Bestätigen"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
